howspace.aiGen = (() => {
    'use strict';

    const promptGenerateWidget = (btn, widget, requestedWidgetType, userPrompt, useWidgetData) => {
        real.button.loading(btn, widget.find('.prompt-input-wrapper'));
        real.ajax.json(real.baseUri + '/api/ai/prompt/generate-widget', {
            type: 'POST',
            data: JSON.stringify({
                'context': {
                    'widget_type': widget.data('widget-type'),
                    'widget_id': widget.data('widget-id')
                },
                'prompt': userPrompt,
                'use_widget_data_in_prompt': useWidgetData,
                'requested_widget_type': requestedWidgetType
            }),
            success: () => {
                setPromptTimeout(widget);
            },
            error: () => {
                real.notification.show(howspace.translate('widget_prompt_failed'), 'danger');
                real.button.reset(btn, widget.find('.prompt-container'));
            }
        });
    };

    // The AI service gives up after 50 seconds and reports it, so this is mainly for answers that never come.
    const PROMPT_TIMEOUT_MS = 90000;

    const setPromptTimeout = widget => {
        clearPromptTimeout(widget);
        widget.removeData('prompt-timed-out');
        const timeoutId = setTimeout(() => {
            // Check if the element with data attribute 'prompt-timeout-timer-id' still exists before showing the notification.
            if ($('[data-prompt-timeout-timer-id="' + timeoutId + '"]').length) {
                real.notification.show(howspace.translate('widget_prompt_timeout'), 'danger');
                widget.data('prompt-timed-out', true);
            }
            real.button.reset(widget.find('.prompt-btn'), widget.find('.prompt-container'));
        }, PROMPT_TIMEOUT_MS);
        widget.dataAndAttr('prompt-timeout-timer-id', timeoutId);
    };

    // An answer that arrives after the timeout message takes it away, unless another message has replaced it.
    const hidePromptTimeoutMessage = widget => {
        if (!widget.data('prompt-timed-out')) {
            return;
        }
        widget.removeData('prompt-timed-out');
        real.notification.hideIfShowing(howspace.translate('widget_prompt_timeout'));
    };

    const clearPromptTimeout = widget => {
        const timeoutId = widget.data('prompt-timeout-timer-id');
        if (timeoutId) {
            widget.removeDataAndAttr('prompt-timeout-timer-id');
            clearTimeout(timeoutId);
        }
    };

    const initGenWidgetPreviewModal = (modal) => {
        modal = $(modal);
        const saveBtn = modal.find('.submit-btn');
        modal.on('click', '.save-btn', () => {
            real.button.loading(saveBtn, modal.find('.modal-body'));
            // Collect the widget data from the modal.
            const dataPayload = real.form.getDataPayload(modal.find('.modal-body'));
            let scaleType; // Only used for pulse widgets.

            switch (modal.data('widget-type')) {
                case 'poll':
                    // Options.
                    dataPayload.poll_options = [];
                    modal.find('.modal-body').find('.option:not(.deleted)').each(function () {
                        dataPayload.poll_options.push(real.form.getDataPayload($(this)));
                    });
                    break;
                case 'pulse':
                    // Scale type.
                    dataPayload.scale_type = modal.find('input[data-name="scale_type"]:checked').val();
                    // Questions.
                    dataPayload.questions = [];
                    modal.find('.question:not(.deleted)').each(function () {
                        dataPayload.questions.push(real.form.getDataPayload($(this)));
                    });

                    // Answering rounds.
                    dataPayload.answering_rounds = [];
                    modal.find('.answering-round:not(.deleted)').each(function () {
                        dataPayload.answering_rounds.push(real.form.getDataPayload($(this)));
                    });

                    // Scale legend.
                    scaleType = modal.find('input[data-name="scale_type"]:checked').val();
                    dataPayload.scale_legend = {};
                    modal.find('.legend-item[data-scale-type="' + scaleType + '"]:not(.d-none)').each(function () {
                        const index = $(this).data('index').toString();
                        const input = $(this).find('input');

                        dataPayload.scale_legend[index] = input.val();
                    });
                    break;
                case 'priority':
                    // Options.
                    dataPayload.priority_options = [];
                    modal.find('.modal-body').find('.option:not(.deleted)').each(function () {
                        dataPayload.priority_options.push(real.form.getDataPayload($(this)));
                    });
                    break;
                case 'allocate':
                    // Options.
                    dataPayload.allocate_options = [];
                    modal.find('.modal-body').find('.option:not(.deleted)').each(function () {
                        dataPayload.allocate_options.push(real.form.getDataPayload($(this)));
                    });
                    break;
                default:
                    // Unsupported widget type.
                    break;
            }
            // Relay the control data to the controller.
            dataPayload.requested_widget_type = modal.data('widget-type');
            dataPayload.target_page_id = modal.data('target-page-id');
            dataPayload.target_column_id = modal.data('target-column-id');
            dataPayload.target_before_widget_id = modal.data('target-before-widget-id');

            savePreviewAsWidget(dataPayload, () => {
                real.button.reset(saveBtn, modal.find('.modal-body'));
            });
        });
    };

    const savePreviewAsWidget = (dataPayload, callback) => {
        real.ajax.json(real.baseUri + '/api/ai/preview/save-widget', {
            type: 'POST',
            data: JSON.stringify(dataPayload),
            success: (response) => {
                if (callback) {
                    callback(response);
                }
            }
        });
    }

    return {
        promptGenerateWidget: promptGenerateWidget,
        setPromptTimeout: setPromptTimeout,
        clearPromptTimeout: clearPromptTimeout,
        hidePromptTimeoutMessage: hidePromptTimeoutMessage,
        initGenWidgetPreviewModal: initGenWidgetPreviewModal,
    }
})();
